module.exports = __webpack_public_path__ + "static/img/wlx-baic-bg-img.36ffe1aa.png";